import { defineComponent as _defineComponent } from 'vue'
import MyProjectsContractContract from '@/views/my-projects/components/contract/contract/MyProjectsContractContract.vue';
import MyProjectsContractBaseData from '@/views/my-projects/components/contract/base-data/MyProjectsContractBaseData.vue';
import MyProjectsContractNotes from '@/views/my-projects/components/contract/notes/MyProjectsContractNotes.vue';
import MyProjectsContractDocuments from '@/views/my-projects/components/contract/contractDocuments/MyProjectsContractDocuments.vue';
import MyProjectsContractsActions from '@/views/my-projects/components/contracts/MyProjectsContractsActions.vue';
import MyProjectContractConfirms from '@/views/my-projects/pages/MyProjectContractConfirms.vue';
import { computed, onMounted, onUnmounted } from 'vue';
import { useRoute } from 'vue2-helpers/vue-router';
import useContract from '@/views/my-projects/composables/useContract';
import BCXNewStuffBanner from '@/components/molecules/BCXNewStuffBanner.vue';
import { useIntervalFn } from '@vueuse/core';
import useAppVersionState from '@/state/appVersionState';
import useNotificationState from '@/state/notificationState';
import { logVerbose } from '@/utils/logger';


export default /*#__PURE__*/_defineComponent({
  __name: 'MyProjectContract',
  setup(__props) {

const { isAppUpdateAvaliable, isNotificationIgnored } = useAppVersionState();
const { loadNotifications } = useNotificationState();
const route = useRoute();
const {
  fetchContractDetail, hasChanges, loadChangedContract, openContractDocumentId
} = useContract();
const closeBanner = () => {
  logVerbose('Popup was closed');
  hasChanges.value = false;
};

const showNewStuffBanner = computed(() => {
  if (hasChanges.value && !(isAppUpdateAvaliable.value && !isNotificationIgnored.value)) {
    logVerbose('The pop-up is displayed');
  }
  return hasChanges.value && !(isAppUpdateAvaliable.value && !isNotificationIgnored.value);
});

useIntervalFn(loadNotifications, 60000);

async function handleLoadStuff() {
  await loadChangedContract();
  await loadNotifications();
}

onMounted(async () => {
  if (route.params.contractId != null) {
    await fetchContractDetail(route.params.contractId as string);
    await loadNotifications();
  }
});

// If an ID exists, it will be deleted. Otherwise you can delete the document from another contract.
onUnmounted(() => {
  openContractDocumentId.value = null;
});

return { __sfc: true,isAppUpdateAvaliable, isNotificationIgnored, loadNotifications, route, fetchContractDetail, hasChanges, loadChangedContract, openContractDocumentId, closeBanner, showNewStuffBanner, handleLoadStuff, MyProjectsContractContract, MyProjectsContractBaseData, MyProjectsContractNotes, MyProjectsContractDocuments, MyProjectsContractsActions, MyProjectContractConfirms, BCXNewStuffBanner }
}

})